import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

/**
 * Attaches a single Jira issue to a bet, for scopes that do not live under the
 * linked epic.
 */
const AddScopeDialog = ({ open, bet, onClose, onSubmit }) => {
  const [jiraKey, setJiraKey] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setJiraKey('');
      setError(null);
    }
  }, [open]);

  const submit = async () => {
    const key = jiraKey.trim().toUpperCase();
    if (!key) {
      setError('Enter a Jira issue key, such as CSU-1234.');
      return;
    }

    setSaving(true);
    setError(null);
    try {
      await onSubmit(key);
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Could not add the scope.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add a scope</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {bet ? `Attach a Jira issue to "${bet.name}".` : 'Attach a Jira issue to this bet.'}
          {' '}It stays on the hill even if it is not a child of the linked epic.
        </DialogContentText>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <TextField
          autoFocus
          fullWidth
          label="Jira issue key"
          placeholder="CSU-1234"
          value={jiraKey}
          onChange={(e) => setJiraKey(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button variant="contained" onClick={submit} disabled={saving}>
          {saving ? 'Adding…' : 'Add scope'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddScopeDialog;
